import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';

import { Input } from '@material-tailwind/react';

import { v4 as uuidv4 } from 'uuid';
import { mintCheck } from '../util/api';
import { useNavigate } from 'react-router-dom';
import data from '../assets/metadata.json';
import skeletonImg from '../assets/imgs/skeleton.webp';
import logo from '../assets/imgs/logo.webp';
import xLogo from '../assets/imgs/x.png';

export default function Maintenance({ isMaintenance }) {
  return (
    <div className='flex flex-col items-center justify-center h-screen z-[9999]'>
      <img src={logo} className='md:h-[80px] h-[60px]' />
    </div>
  );
}
